var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalsiteAmico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.42,268.25c-84.56-48.82-221.21-48.82-305.22,0s-83.57,128,1,176.8,221.22,48.82,305.23,0S486,317.07,401.42,268.25Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.16,237.06c9.73,5.62,9.79,14.74.11,20.36s-25.41,5.62-35.15,0-9.79-14.74-.11-20.36S272.42,231.44,282.16,237.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,396.17l9.07,4.91a5.91,5.91,0,0,0,5.76-.09l127.82-74.14a2.94,2.94,0,0,0-.07-5.13l-12-6.48L73.33,391A3,3,0,0,0,73.41,396.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.82,379.32c-18.77-10.83-49.1-10.83-67.74,0s-18.55,28.41.22,39.25,49.1,10.83,67.74,0S375.59,390.16,356.82,379.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.12,329c-7.5-4.22-19.55-4.1-26.91.28s-7.25,11.36.25,15.59,19.55,4.1,26.91-.29S435.62,333.27,428.12,329Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.88,169.74H262.4c0,19.26.7,82.68.7,82.68h0a.76.76,0,0,0,.45.63,2.39,2.39,0,0,0,2.18,0,.76.76,0,0,0,.45-.63h0S266.88,189,266.88,169.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.84,161.05h-4.48C249.51,181,247,243.73,247,243.73h0a.82.82,0,0,0,.46.64,2.46,2.46,0,0,0,2.18,0,.79.79,0,0,0,.45-.64h0S254.33,180.7,257.84,161.05Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.44,161.05h4.48c3.85,19.93,6.35,82.68,6.35,82.68h0a.79.79,0,0,1-.45.64,2.46,2.46,0,0,1-2.18,0,.79.79,0,0,1-.45-.64h0S274.94,180.7,271.44,161.05Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.88,169.74H262.4c0,19.26.7,82.68.7,82.68h0a.76.76,0,0,0,.45.63,2.39,2.39,0,0,0,2.18,0,.76.76,0,0,0,.45-.63h0S266.88,189,266.88,169.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M257.84,161.05h-4.48C249.51,181,247,243.73,247,243.73h0a.82.82,0,0,0,.46.64,2.46,2.46,0,0,0,2.18,0,.79.79,0,0,0,.45-.64h0S254.33,180.7,257.84,161.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.44,161.05h4.48c3.85,19.93,6.35,82.68,6.35,82.68h0a.79.79,0,0,1-.45.64,2.46,2.46,0,0,1-2.18,0,.79.79,0,0,1-.45-.64h0S274.94,180.7,271.44,161.05Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288.74,160.48h-.47c-.91-2.62-3.12-5.13-6.64-7.16-9.45-5.45-24.71-5.45-34.09,0-3.5,2-5.68,4.54-6.56,7.16h-.45v2.71h0c0,3.58,2.4,7.15,7.12,9.88,9.44,5.45,24.71,5.45,34.09,0,4.69-2.73,7-6.3,7-9.88h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.63,150.61c9.44,5.45,9.49,14.29.11,19.74s-24.65,5.45-34.09,0-9.49-14.29-.11-19.74S272.18,145.15,281.63,150.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.47,142.54H252.81c0,7.77,3.63,14.36,4.75,16.32a1.74,1.74,0,0,0,.15.26l.05.09h0a4.84,4.84,0,0,0,1.69,1.5,11.46,11.46,0,0,0,10.42,0,4.34,4.34,0,0,0,1.9-1.94C272.94,156.72,276.47,150.21,276.47,142.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,137.7c4.63,2.67,4.65,7,0,9.68s-12.09,2.68-16.73,0-4.66-7-.05-9.68S268.34,135,273,137.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,139.48a34,34,0,0,0-3.41-14.6,12.39,12.39,0,0,1-1.62-4.45c-.11-1.58.76-3.38,2.32-3.69a3.31,3.31,0,0,1,3.19,1.52,9.55,9.55,0,0,1,1.26,3.5c1.17,5.47,2.14,11.1,1.4,16.65a7,7,0,0,1-.38,1.88,1.76,1.76,0,0,1-1.35,1.07,1.29,1.29,0,0,1-1.07-.42A2.74,2.74,0,0,1,263.36,139.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.66,139.94h0a.19.19,0,0,1-.17-.21A42.41,42.41,0,0,0,261,119a.2.2,0,0,1,.1-.26.19.19,0,0,1,.25.1,42.63,42.63,0,0,1,3.55,20.93A.19.19,0,0,1,264.66,139.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.85,131.24c-1-.64-2.23-1.34-2.55-2.52a2.71,2.71,0,0,1,1.2-2.83,4.1,4.1,0,0,1,3.16-.42,8.57,8.57,0,0,1,2.91,1.46,19.44,19.44,0,0,1,4,3.83,20.74,20.74,0,0,1,3.21,5.78,22.45,22.45,0,0,1,1.15,4.16c.18,1.12.51,3-.65,3.71a1.69,1.69,0,0,1-1.7,0,3,3,0,0,1-1.16-1.34,13.42,13.42,0,0,1-.61-1.68,15.74,15.74,0,0,0-3.6-5.9A26.23,26.23,0,0,0,251.85,131.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.78,143.06h0a.24.24,0,0,1-.28-.18,23.17,23.17,0,0,0-12.21-15.68.26.26,0,0,1-.11-.32.25.25,0,0,1,.32-.11,23.67,23.67,0,0,1,12.47,16A.25.25,0,0,1,263.78,143.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,128.83c.84-.89,1.81-1.86,1.82-3.08a2.7,2.7,0,0,0-1.88-2.43,4,4,0,0,0-3.16.39,8.39,8.39,0,0,0-2.45,2.15,19.44,19.44,0,0,0-2.91,4.72,20.89,20.89,0,0,0-1.64,6.4,22.16,22.16,0,0,0-.06,4.31c.11,1.13.26,3,1.57,3.44a1.71,1.71,0,0,0,1.64-.46,3,3,0,0,0,.78-1.58,13.38,13.38,0,0,0,.16-1.78,16,16,0,0,1,2-6.62A26.2,26.2,0,0,1,275,128.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.44,143.29h0a.24.24,0,0,0,.22-.25,23.16,23.16,0,0,1,7.85-18.26.24.24,0,0,0-.31-.36,23.67,23.67,0,0,0-8,18.65A.24.24,0,0,0,266.44,143.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.73 95.77 428.26 115.12 428.19 140.75 394.66 121.39 394.73 95.77",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.73 95.77 394.66 121.39 391.56 123.2 391.64 93.98 394.73 95.77",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.19 140.75 428.18 144.34 391.56 123.2 394.66 121.39 428.19 140.75",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.79,125.34l44.13,25.48L432,113,387.9,87.51Zm3.77-2.14L391.64,94l3.09,1.79,33.53,19.35-.07,25.63v3.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.9 87.51 391 85.7 435.13 111.18 432.03 112.98 387.9 87.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.13 111.18 435.03 149.01 431.92 150.82 432.03 112.98 435.13 111.18",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 64.42 373.71 83.78 373.64 109.4 340.11 90.04 340.18 64.42",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.18 64.42 340.11 90.04 337 91.85 337.08 62.63 340.18 64.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.64 109.4 373.63 112.99 337 91.85 340.11 90.04 373.64 109.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.24,94l44.13,25.48.1-37.83L333.34,56.16ZM337,91.85l.08-29.22,3.1,1.79,33.53,19.36-.07,25.62V113Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.34 56.16 336.45 54.35 380.58 79.83 377.47 81.64 333.34 56.16",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.58 79.83 380.47 117.67 377.37 119.47 377.47 81.64 380.58 79.83",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.39 105.5 396.24 112.69 396.22 119.73 426.63 137.29 426.65 130.25 420.86 118.74 415.65 122.78 417.5 128.5 414.82 123.42 405.39 105.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.38,109c-1.44-.83-2.6-.16-2.6,1.48a5.69,5.69,0,0,0,2.58,4.48c1.43.82,2.6.16,2.6-1.48A5.71,5.71,0,0,0,415.38,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.83 74.15 341.69 81.35 341.67 88.38 372.08 105.94 372.1 98.91 366.31 87.39 361.1 91.43 362.94 97.15 360.27 92.08 350.83 74.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,77.69c-1.43-.82-2.59-.16-2.6,1.48a5.7,5.7,0,0,0,2.59,4.48c1.43.83,2.59.16,2.6-1.48A5.72,5.72,0,0,0,360.82,77.69Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.5,304.23l-18.05.71-18.05-.33c-.65,12.19,1.86,24.59,5.21,30.62h0a8.2,8.2,0,0,0,3.61,3.6c5.36,3,14,2.93,19.22-.2a8,8,0,0,0,3.53-3.77C431.17,328.72,433.4,316.35,432.5,304.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.09,296.89c7.11,4,7.22,10.63.24,14.78s-18.41,4.28-25.52.27-7.23-10.62-.24-14.78S420,292.88,427.09,296.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.31,298.55c5.55,3.12,5.63,8.29.19,11.53s-14.36,3.34-19.92.21S399,302,404.4,298.76,418.76,295.42,424.31,298.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424.31,298.55c5.55,3.12,5.63,8.29.19,11.53s-14.36,3.34-19.92.21S399,302,404.4,298.76,418.76,295.42,424.31,298.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,227.09c-40.53,13.75-40.61,41-31.24,60.24,2.35,3.9,9.37,5.93,15.21-18.23l-10.67,1.48L429,264.14l3.14-9.7-10.38.88,13.12-5.68A194.3,194.3,0,0,1,443.31,227.09Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,227.09c-40.53,13.75-40.61,41-31.24,60.24,2.35,3.9,9.37,5.93,15.21-18.23l-10.67,1.48L429,264.14l3.14-9.7-10.38.88,13.12-5.68A194.3,194.3,0,0,1,443.31,227.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.31,227.09c-40.53,13.75-40.61,41-31.24,60.24,2.35,3.9,9.37,5.93,15.21-18.23l-10.67,1.48L429,264.14l3.14-9.7-10.38.88,13.12-5.68A194.3,194.3,0,0,1,443.31,227.09Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,234c-21.28,16.5-23,35.18-16.75,54.6C412.8,271.49,410.3,254.17,431.88,234Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,255.46c40.15,5.22,45.28,30.45,40.17,50.07-1.46,4.06-7.59,7.24-17.5-14.08l10.17-.61-12.68-3.68-4.7-8.41,9.78-1.11-13.22-2.83A184,184,0,0,0,374.71,255.46Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,255.46c40.15,5.22,45.28,30.45,40.17,50.07-1.46,4.06-7.59,7.24-17.5-14.08l10.17-.61-12.68-3.68-4.7-8.41,9.78-1.11-13.22-2.83A184,184,0,0,0,374.71,255.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,255.46c40.15,5.22,45.28,30.45,40.17,50.07-1.46,4.06-7.59,7.24-17.5-14.08l10.17-.61-12.68-3.68-4.7-8.41,9.78-1.11-13.22-2.83A184,184,0,0,0,374.71,255.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.6,259.76c22.8,11.36,27.89,28.36,25.69,47.54C411.26,291,410.36,274.44,386.6,259.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.43,264.08c-36.76,1-43.73,23.3-40.94,41.51.94,3.8,6.19,7.25,17.12-11.1L422.48,293l11.8-2.15,5-7.16-8.74-1.91,12.21-1.34A167.38,167.38,0,0,1,455.43,264.08Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.29,266.86c-21.65,8.14-27.83,23-27.62,40.57C419.12,292.78,421.46,277.92,444.29,266.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.43,264.08c-36.76,1-43.73,23.3-40.94,41.51.94,3.8,6.19,7.25,17.12-11.1L422.48,293l11.8-2.15,5-7.16-8.74-1.91,12.21-1.34A167.38,167.38,0,0,1,455.43,264.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.09,53.1h0c-.88-3.06-7.09-8.88-13.27-8.75a5.16,5.16,0,0,0-1.74.34L79,113a11.62,11.62,0,0,0-5.81,10v259.8c0,6.61,7.63,12.93,14.79,9.89l0,0a2.62,2.62,0,0,0,.46-.19L208.59,324a11.49,11.49,0,0,0,5.8-10V54.35A2.84,2.84,0,0,0,214.09,53.1Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.09,53.1h0c-.88-3.06-7.09-8.88-13.27-8.75a5.16,5.16,0,0,0-1.74.34L79,113a11.62,11.62,0,0,0-5.81,10v259.8c0,6.61,7.63,12.93,14.79,9.89l0,0a2.62,2.62,0,0,0,.46-.19L208.59,324a11.49,11.49,0,0,0,5.8-10V54.35A2.84,2.84,0,0,0,214.09,53.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,150.45a5.74,5.74,0,0,1,2.91-5L204.36,82a2.87,2.87,0,0,1,4.29,2.5V294a5.75,5.75,0,0,1-2.9,5L94.23,362.54a2.88,2.88,0,0,1-4.3-2.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18,123v259.8c0,6.61,7.63,12.93,14.79,9.89l0,0A2.85,2.85,0,0,1,84.19,390V130.17a11.45,11.45,0,0,1,1.94-6.34L74.37,118A11.43,11.43,0,0,0,73.18,123Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.83,44.34a5.16,5.16,0,0,0-1.74.34L79,113A11.4,11.4,0,0,0,74.37,118l11.76,5.88A11.45,11.45,0,0,1,90,120.19L210.1,51.86a2.86,2.86,0,0,1,4,1.24h0C213.22,50,207,44.21,200.83,44.34Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09,94.76c.85-.49,1.55-.11,1.55.86a3.39,3.39,0,0,1-1.54,2.65l-23.56,13.61c-.84.49-1.52.08-1.53-.89a3.36,3.36,0,0,1,1.52-2.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.48,111.85c.84-.48,1.52-.1,1.53.87a3.38,3.38,0,0,1-1.52,2.65c-.85.49-1.54.09-1.55-.88A3.37,3.37,0,0,1,134.48,111.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,92.78c1.69-1,3.05-.2,3.05,1.74a6.73,6.73,0,0,1-3,5.29c-1.68,1-3.08.17-3.09-1.76A6.76,6.76,0,0,1,149.56,92.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,337.35c3.43-2,6.2-.4,6.21,3.54a13.72,13.72,0,0,1-6.17,10.78c-3.43,2-6.28.36-6.29-3.58A13.73,13.73,0,0,1,149.57,337.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.68,96h0l-6.49-3.44v0a2.82,2.82,0,0,0-3.12-.21L110.57,155.85a5.77,5.77,0,0,0-2.9,5V370.44a2.83,2.83,0,0,0,1.83,2.65v0l6.54,3.51h0l.11.05a2.84,2.84,0,0,0,2.74,0l111.52-63.55a5.75,5.75,0,0,0,2.9-5V98.61A2.82,2.82,0,0,0,231.68,96Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.32,105.93V98.61A2.82,2.82,0,0,0,231.68,96h0l-6.49-3.44v0a2.82,2.82,0,0,0-3.12-.21L110.57,155.85a5.77,5.77,0,0,0-2.9,5v9.61l6.94,4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,96h0l-6.49-3.44v0a2.82,2.82,0,0,0-3.12-.21L110.57,155.85a5.77,5.77,0,0,0-2.9,5V370.44a2.83,2.83,0,0,0,1.83,2.65v0l6.54,3.51h0l.11.05a2.84,2.84,0,0,0,2.74,0l111.52-63.55a5.75,5.75,0,0,0,2.9-5V98.61A2.82,2.82,0,0,0,231.68,96Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.67,160.85V370.44a2.83,2.83,0,0,0,1.83,2.65v0l6.54,3.51a2.85,2.85,0,0,1-1.42-2.48V164.55a5.85,5.85,0,0,1,.45-2.24l-6.82-3.94A5.78,5.78,0,0,0,107.67,160.85Z",
    style: {
      fill: "#FB923C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.21,92.59v0a2.82,2.82,0,0,0-3.12-.21L110.57,155.85a5.72,5.72,0,0,0-2.33,2.52l6.82,3.94a5.74,5.74,0,0,1,2.45-2.75L229,96.11a2.8,2.8,0,0,1,2.65-.07h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.59,162.83c14.71-8.49,26.67-1.68,26.72,15.22s-11.84,37.49-26.55,46-26.67,1.68-26.72-15.22S133.88,171.32,148.59,162.83Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,178.6a7.13,7.13,0,0,0,2-9.4,3.86,3.86,0,0,0,1.88-1.77,2.07,2.07,0,0,0-2.69-2.76,2.92,2.92,0,0,0-1.16-3.4,2.76,2.76,0,0,0-3.42.63,1.87,1.87,0,0,0-1.27-1.83,3.76,3.76,0,0,0-2.36.15c-.77.26-1.48.64-2.25.88a17.06,17.06,0,0,1-4,.52,8.17,8.17,0,0,0-3.9,1,3.49,3.49,0,0,0-1.53,4,2.24,2.24,0,0,0-1.62-.86,2.17,2.17,0,0,0-1.66.71c.85.52,1.67,1.09,2.52,1.61a2.29,2.29,0,0,0-2.59,1,5.06,5.06,0,0,0-.46,2.73,36.27,36.27,0,0,0,1.88,10.47c.58,1.74,1.94,3.94,3.59,4.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.29,192l4,3.44,2.13,12.22a65.47,65.47,0,0,0,4.62-8.2C168.23,194.75,166.76,192,159.29,192Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76,224c6.91-4,13.2-10.64,17.91-18.33-.38-6.62-1.36-13.74-7.38-13.74l-17.89.12-3.65.39L136,227.66C139.82,227.85,144.15,226.69,148.76,224Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.76,224c6.91-4,13.2-10.64,17.91-18.33-.38-6.62-1.36-13.74-7.38-13.74l-17.89.12-3.65.39L136,227.66C139.82,227.85,144.15,226.69,148.76,224Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.37,194.34c1.67,5.32.62,12.74,0,16.08-4.24-5.83-8.2-11.67-9.45-14l5.91-2.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,199.22l1.46-.34a48.54,48.54,0,0,1,1.77,5.7c-.18,2.35-.51,4.45-.76,5.84-.84-1.14-1.66-2.29-2.45-3.4A39,39,0,0,0,153.9,199.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.93,199.53l0-.31,1.46-.34.08.21a1.91,1.91,0,0,1-.83.44A1.73,1.73,0,0,1,153.93,199.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11,195.4l-1.15-.74-2.67,1.46a6.12,6.12,0,0,0,3.16,1.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.88,195.12l.35-.78,1.35.84a2.42,2.42,0,0,1-.87,1.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11,195.4l-1.15-.74-2.67,1.46a6.12,6.12,0,0,0,3.16,1.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.88,195.12l.35-.78,1.35.84a2.42,2.42,0,0,1-.87,1.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,197.37a6.64,6.64,0,0,1,.66-2l1.77-.28a6.64,6.64,0,0,1,.83,1.34,6.59,6.59,0,0,1-.35,2.42,3.14,3.14,0,0,1-1.46.34A3.77,3.77,0,0,1,152.45,197.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.73,194.78c-2.8-.05-4.52,2.19-7.09,2.95l-5.24-5.65,2-3a5.4,5.4,0,0,1,1.55-1.5h0l0,1.1a1.89,1.89,0,0,0,.93,1.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.73,194.78c1.57-.48,3.9,1.47,3.9,1.47-.82-4.52-3.28-6.3-3.89-6.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.75,192.47l-2.42.39a7.15,7.15,0,0,0-5.85,5.62,85.37,85.37,0,0,0-1.58,20.59L139,214C140.14,205.31,142.42,198.16,137.75,192.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.86,217.81l0-1a.6.6,0,0,1,.22-.46.64.64,0,0,0,.22-.49v-1.6a.78.78,0,0,0-.8-.78c-5,.07-9.88,2.45-11.21,5.26a4.19,4.19,0,0,0,0,2.71c-.87,1.13-.45,1.71,0,2.53a14.91,14.91,0,0,0,1.44,1.19C132,220,138.86,217.81,138.86,217.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.67,216.69a17,17,0,0,0-6.33,4.8,4.51,4.51,0,0,1-.2-.92A11.18,11.18,0,0,1,133.67,216.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.31,216.09a.58.58,0,0,1-.18.3.6.6,0,0,0-.22.46v.08a16.66,16.66,0,0,0-9.25,4.68C132,218.26,137.06,216.54,139.31,216.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76,224a46.87,46.87,0,0,0,11.4-9.53c-6.43,0-15.39.4-21.26,2.43l0,.88s-6.84,2.17-10.08,7.4C133.67,228.73,140.81,228.62,148.76,224Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35,217.84l.11-1.09-.56.18,0,.88a23.1,23.1,0,0,0-4.57,2.17,6.71,6.71,0,0,0-1,2c1.34-1.89,2.81-2.65,5.67-3.38,2.59.4,7.12,2.31,11.72,4.23.44-.29.88-.59,1.31-.9C146.41,220,140.79,217.94,139.35,217.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21,187.76l-.08,0a4.57,4.57,0,0,1-2.35-3c-.15-.65-.28-1.3-.38-1.95s-.53,0-.53,0,0,1.44.07,3.15c0,.9,0,1.88.06,2.77a1.89,1.89,0,0,0,.93,1.57l7.8,4.55v-5.55A14.22,14.22,0,0,1,148.21,187.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.31 186.77 146.31 186.77 146.32 186.77 146.31 186.77",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,187.65a5.39,5.39,0,0,1-1-2,4.71,4.71,0,0,0,2,2.07l.08,0a14.22,14.22,0,0,0,5.53,1.47v1.42a13.9,13.9,0,0,1-3.27-.69A7.33,7.33,0,0,1,147.1,187.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.54,170a37.16,37.16,0,0,1-.94,14.47,11.34,11.34,0,0,1-1.14,3,4.85,4.85,0,0,1-2.35,2.08,7.4,7.4,0,0,1-3.88,0,19.67,19.67,0,0,1-6.84-2.1c-2-1.24-3.67-3.48-3.47-5.87a4.09,4.09,0,0,1-3.92.22,4.15,4.15,0,0,1-2.15-3.33,2.56,2.56,0,0,1,4.28-2.42,8.6,8.6,0,0,1,1.59,1.86,2.8,2.8,0,0,0,.79.85,1,1,0,0,0,1.1,0,1.43,1.43,0,0,0,.31-1.19l-.14-3a1.21,1.21,0,0,1,.67-1.12,3,3,0,0,0,1.36-1.57,6.15,6.15,0,0,0,.38-1.82.75.75,0,0,1,1-.63A22.28,22.28,0,0,0,162.54,170Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.88 177.35 158.6 181.93 155.35 182.54 155.88 177.35",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23,184.12l2.46,1.2a1.6,1.6,0,0,1-1.87.53A1.43,1.43,0,0,1,152.23,184.12Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23,184.12l2.46,1.2a1.6,1.6,0,0,1-1.87.53A1.43,1.43,0,0,1,152.23,184.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.68,185.93a1.39,1.39,0,0,1-.86-.08,1.32,1.32,0,0,1-.66-1.3,1.55,1.55,0,0,1,1,.34A1.53,1.53,0,0,1,153.68,185.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.18,177.53a.93.93,0,1,0,1-.83A.92.92,0,0,0,151.18,177.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,178a.93.93,0,1,0,1.85.19A.93.93,0,0,0,159,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,174.41l1.92,1.63a1.32,1.32,0,0,0-.26-1.49A1.57,1.57,0,0,0,160.27,174.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.34,173.5l-2.2,1.22a1.31,1.31,0,0,1,.55-1.42A1.58,1.58,0,0,1,152.34,173.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.09 171.67 197.1 174.25 185.54 180.92 185.53 178.34 197.09 171.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.18 184.02 203.19 186.6 185.59 196.76 185.58 194.18 203.18 184.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.94 175.42 208.95 178 185.57 191.5 185.56 188.92 208.94 175.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.05 154.29 218.06 156.87 185.53 175.66 185.52 173.07 218.05 154.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.49 145.25 224.5 147.84 185.51 170.34 185.5 167.76 224.49 145.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.37 140.13 216.39 145.3 185.49 163.14 185.48 157.97 216.37 140.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.91 244.11 120.91 368.23 166.68 342.15 166.68 217.71 120.91 244.11",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.01 182.89 169.61 216.01 169.61 340.48 227.01 307.77 227.01 182.89",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.91 244.11 120.91 368.23 166.68 342.15 166.68 217.71 120.91 244.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.01 182.89 169.61 216.01 169.61 340.48 227.01 307.77 227.01 182.89",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "204.54 291.12 204.54 293.35 177.39 309.02 177.38 306.8 204.54 291.12",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.42 278.39 219.43 280.63 177.38 304.9 177.37 302.67 219.42 278.39",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.13 287.13 197.13 289.36 177.37 300.77 177.36 298.55 197.13 287.13",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.4 270.15 219.41 272.38 177.36 296.65 177.35 294.42 219.4 270.15",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.39 266.02 219.4 268.25 177.34 292.53 177.34 290.3 219.39 266.02",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.46 274.42 187.46 276.66 177.32 282.52 177.31 280.28 187.46 274.42",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.35 251.88 219.35 254.11 177.31 278.39 177.3 276.16 219.35 251.88",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.34 247.76 219.34 249.99 177.29 274.27 177.29 272.04 219.34 247.76",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.32 243.64 219.33 245.87 177.28 270.14 177.28 267.92 219.32 243.64",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.4 242.27 204.41 244.5 177.25 260.18 177.25 257.95 204.4 242.27",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.28 229.54 219.29 231.78 177.24 256.06 177.24 253.82 219.28 229.54",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.27 225.42 219.28 227.65 177.23 251.93 177.22 249.7 219.27 225.42",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.25 217.17 219.26 219.41 177.21 243.69 177.2 241.45 219.25 217.17",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.26 221.3 219.27 223.53 177.22 247.81 177.21 245.58 219.26 221.3",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.95 202.75 212.95 204.98 177.16 225.65 177.15 223.42 212.95 202.75",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.49 209.54 215.5 211.78 177.18 233.9 177.17 231.66 215.49 209.54",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.38 212.98 202.38 215.21 177.17 229.77 177.16 227.54 202.38 212.98",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.19 195.02 219.19 197.25 177.14 221.53 177.14 219.3 219.19 195.02",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.48 299.17 219.49 301.39 177.44 325.67 177.43 323.44 219.48 299.17",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.21 316.15 197.21 318.38 177.45 329.79 177.44 327.56 197.21 316.15",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.89 301.15 208.9 303.38 177.43 321.55 177.42 319.32 208.89 301.15",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.46 290.92 219.47 293.15 177.42 317.43 177.41 315.19 219.46 290.92",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "204.54 291.12 204.54 293.35 177.39 309.02 177.38 306.8 204.54 291.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.42 278.39 219.43 280.63 177.38 304.9 177.37 302.67 219.42 278.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.13 287.13 197.13 289.36 177.37 300.77 177.36 298.55 197.13 287.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.4 270.15 219.41 272.38 177.36 296.65 177.35 294.42 219.4 270.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.39 266.02 219.4 268.25 177.34 292.53 177.34 290.3 219.39 266.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "187.46 274.42 187.46 276.66 177.32 282.52 177.31 280.28 187.46 274.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.35 251.88 219.35 254.11 177.31 278.39 177.3 276.16 219.35 251.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.34 247.76 219.34 249.99 177.29 274.27 177.29 272.04 219.34 247.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.32 243.64 219.33 245.87 177.28 270.14 177.28 267.92 219.32 243.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "204.4 242.27 204.41 244.5 177.25 260.18 177.25 257.95 204.4 242.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.28 229.54 219.29 231.78 177.24 256.06 177.24 253.82 219.28 229.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.27 225.42 219.28 227.65 177.23 251.93 177.22 249.7 219.27 225.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.25 217.17 219.26 219.41 177.21 243.69 177.2 241.45 219.25 217.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.26 221.3 219.27 223.53 177.22 247.81 177.21 245.58 219.26 221.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.95 202.75 212.95 204.98 177.16 225.65 177.15 223.42 212.95 202.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.49 209.54 215.5 211.78 177.18 233.9 177.17 231.66 215.49 209.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.38 212.98 202.38 215.21 177.17 229.77 177.16 227.54 202.38 212.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.19 195.02 219.19 197.25 177.14 221.53 177.14 219.3 219.19 195.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "219.48 299.17 219.49 301.39 177.44 325.67 177.43 323.44 219.48 299.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.21 316.15 197.21 318.38 177.45 329.79 177.44 327.56 197.21 316.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.89 301.15 208.9 303.38 177.43 321.55 177.42 319.32 208.89 301.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.46 290.92 219.47 293.15 177.42 317.43 177.41 315.19 219.46 290.92",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "155.08 234.34 155.09 238.64 126.59 255.06 126.58 250.76 155.08 234.34",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.13 244.82 151.14 246.97 126.61 261.1 126.61 258.95 151.13 244.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.41 323.06 162.42 327.36 151.9 333.43 151.89 329.14 162.41 323.06",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.02 288.64 142.03 292.94 126.73 301.74 126.71 297.45 142.02 288.64",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.1 277.05 162.11 281.35 145.04 291.2 145.03 286.91 162.1 277.05",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.7 268.68 153.71 270.82 126.68 286.39 126.68 284.25 153.7 268.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.35 320.86 151.35 323 126.83 337.13 126.82 334.99 151.35 320.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.31 314.6 155.31 316.75 126.81 333.17 126.81 331.02 155.31 314.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.18 306.65 162.19 308.8 126.8 329.2 126.8 327.05 162.18 306.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.28 302.44 155.29 306.74 126.79 323.16 126.78 318.87 155.28 302.44",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.81 291.7 157.82 293.85 126.75 311.75 126.75 309.61 157.81 291.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.03 291.07 152.04 293.21 126.74 307.79 126.74 305.64 152.03 291.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.36 271.11 156.37 273.27 126.69 290.37 126.69 288.21 156.36 271.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.72 261.23 159.72 263.38 126.67 282.43 126.67 280.28 159.72 261.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.14 255.67 155.15 259.96 126.65 276.38 126.64 272.09 155.14 255.67",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.95 253.52 142.95 255.67 126.62 265.06 126.62 262.92 142.95 253.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.09 337.73 158.1 339.88 126.89 357.87 126.88 355.72 158.09 337.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.24 336.55 153.24 338.71 126.87 353.9 126.87 351.75 153.24 336.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.85 331.47 147.86 335.76 126.86 347.86 126.84 343.57 147.85 331.47",
    style: {
      fill: "#FB923C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.38,393.45a9.41,9.41,0,0,0,7.07,2.6,21.37,21.37,0,0,0,7.49-1.89c2.39-1,5.39-3.73,8-3.68a63.74,63.74,0,0,0,7.57-.52,39.39,39.39,0,0,0-1.08-10.25l-12.08-.32c-3.26,4.47-9.6,8.18-14.4,9.58a4.22,4.22,0,0,0-3,3.17.22.22,0,0,1,0,.08A5.12,5.12,0,0,0,292.38,393.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.92,390.48c-2.59-.05-5.59,2.7-8,3.68a21.37,21.37,0,0,1-7.49,1.89,9.41,9.41,0,0,1-7.07-2.6,5.12,5.12,0,0,1-.42-1.23.22.22,0,0,0,0-.08,4,4,0,0,0,0,1.61,5.12,5.12,0,0,0,.42,1.23,9.41,9.41,0,0,0,7.07,2.6,21.35,21.35,0,0,0,7.49-1.88c2.39-1,5.39-3.74,8-3.69a56.42,56.42,0,0,0,7.45-.43c.06-.54.09-1.08.12-1.62A63.74,63.74,0,0,1,314.92,390.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.13,400.18a18.52,18.52,0,0,1-.39,3.93,9.12,9.12,0,0,1-3.59,5.73,11.6,11.6,0,0,1-5.71,1.52,12.75,12.75,0,0,1-5.22-.54,5.87,5.87,0,0,1-3.06-2.5.17.17,0,0,0,0,.07,5.46,5.46,0,0,0,3.52,3.66,12.59,12.59,0,0,0,5.22.54,11.47,11.47,0,0,0,5.71-1.52,9.11,9.11,0,0,0,3.6-5.73,19.92,19.92,0,0,0,.39-3.93,6.64,6.64,0,0,1,2.1-4.81,11.61,11.61,0,0,0,.92-.94,2.33,2.33,0,0,0,.56-1.72c0-.24,0-.48-.07-.72-.48.56-1.6,1.89-1.88,2.15A6.69,6.69,0,0,0,352.13,400.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.22,386.48a14.37,14.37,0,0,1-1,8,30.31,30.31,0,0,1-4.22,6.94,20.87,20.87,0,0,0-2.21,3.22,5.73,5.73,0,0,0-.62,3.71,5.87,5.87,0,0,0,3.06,2.5,12.75,12.75,0,0,0,5.22.54,11.6,11.6,0,0,0,5.71-1.52,9.12,9.12,0,0,0,3.59-5.73,18.52,18.52,0,0,0,.39-3.93,6.69,6.69,0,0,1,2.11-4.81c.28-.26,1.4-1.59,1.88-2.15a14.66,14.66,0,0,0-1.94-5.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.83,273.5s-3.06,40.12-2.79,51.28,1.39,55.27,1.39,55.27c6.25,3.65,15.28.93,15.28.93.73-35.21,4.05-42.78,1.8-55.67,1.59-9.57,3.79-31.86,3.79-31.86,3.11,26.81,5.37,40.63,5.37,40.63l7.44,53.67c6.11,3.19,13.82,0,13.82,0,0-30.59.66-43.53-2.52-63.73-.17-31.09-1.75-50-1.75-50Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.22,283.86c2.13,5.23,8.82,5.23,8.82,5.23l1.19,5.94-.44,21.13c1.28-10.28,2.51-22.71,2.51-22.71l-.83-6.36A17.66,17.66,0,0,1,316.22,283.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.61,228.7,283.82,233l-13.26-14.22a10.94,10.94,0,0,1-2.63-4.9l-.75-3.15a8.56,8.56,0,0,0-.94-2.35c-.65-1.12-1.34-2.24-1.93-3.34a1.85,1.85,0,0,0-.76-.87,1.11,1.11,0,0,0-1.23.3,1.87,1.87,0,0,0-.43,1.27,5.65,5.65,0,0,0,.25,1.34c.18.68.36,1.36.55,2a2.8,2.8,0,0,1,.13.86.91.91,0,0,1-.39.75c-.57.35-8.74-7.25-10.11-10.72-.37-.94-3.3-.39-1.53,3.4a2.64,2.64,0,0,0-.93,2.15c-.06,1-.11,2.07-.17,3.1a11.53,11.53,0,0,0,.12,3,9.34,9.34,0,0,0,2.23,3.92,18.79,18.79,0,0,0,6.67,4.76,11.06,11.06,0,0,1,4.71,4l12.68,19.12a9.09,9.09,0,0,0,13.29,2l6.7-5.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.58,210.87c-6.51-.37-8.22,3-12.33,6.86S287.4,229,287.4,229A15.49,15.49,0,0,0,296,241.15l14.33-10.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,276.54s-24.26,8.87-44-2.19c0,0,1.2-14.12,1.55-22.35s-2.48-24.12-2.9-28.38.14-11.63,5.16-12.75c9.31-2,26.81,0,26.81,0l10.45,11.55C353.24,245,352.49,268.66,351.74,276.54Z",
    style: {
      fill: "#FB923C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.74,276.54s-24.26,8.87-44-2.19c0,0,1.2-14.12,1.55-22.35s-2.48-24.12-2.9-28.38.14-11.63,5.16-12.75c9.31-2,26.81,0,26.81,0l10.45,11.55C353.24,245,352.49,268.66,351.74,276.54Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.24,271.29v0h0v0s0,0,0-.05l0-.05s0,0,0-.05l0,0,0-.05s0,0,0-.05h0l-9.65-18.46,0-.05,0,0,0-.06,0-.06,0-.06,0-.06,0-.06,0,0,0-.06,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v0l0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0a.86.86,0,0,0-.14-.13l0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0h0l0,0,0,0h0l0,0h0l0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.05,0-.05,0-.05,0-.06,0-.06,0-.07,0,0,0-11.26-6.51h0l-.07,0-.06,0-.06,0-.06,0-.06,0-.06,0-.06,0-.06,0-.06,0h-.21a.21.21,0,0,0-.17.07l-1.37,1.53h0c-.11.09-.12.27,0,.57l9.65,18.46a6.34,6.34,0,0,0,2.15,2.09l11.26,6.5c.58.33.93.35,1,.11,0,0,0,.08,0,.1h0l1.37-1.53a.16.16,0,0,0,0-.07s0,0,0-.06ZM265,245.15s0,0,.08,0h0l0,0Zm12.92,7.46.31.27h0Zm.7.7.13.15h0Zm10.27,19.52a.94.94,0,0,0-.11-.36,1.7,1.7,0,0,1,.12.33h0Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.24,271.29v0h0v0s0,0,0-.05l0-.05s0,0,0-.05l0,0,0-.05s0,0,0-.05h0l-9.65-18.46L279.09,254l9.66,18.47a1.7,1.7,0,0,1,.12.33h0a.24.24,0,0,1-.05.2h0l1.37-1.53a.16.16,0,0,0,0-.07s0,0,0-.06Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.43,252.42l0,0,0-.06,0-.06,0-.06,0-.06,0-.06,0,0,0-.06,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v0l0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0a.86.86,0,0,0-.14-.13l0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0h0l0,0,0,0h0l0,0h0l0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.05,0-.05,0-.05,0-.06,0-.06,0-.07,0,0,0-11.26-6.51h0l-.07,0-.06,0-.06,0-.06,0-.06,0-.06,0-.06,0-.06,0-.06,0h-.21a.21.21,0,0,0-.17.07l-1.37,1.53c.06-.07.17-.08.33-.05h0a2.31,2.31,0,0,1,.62.27l11.26,6.5a7.17,7.17,0,0,1,.64.43h0c.21.17.42.35.62.54h0a6.79,6.79,0,0,1,.52.58h0a4.21,4.21,0,0,1,.36.54l1.37-1.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.09,271.2c-3.81-2.39-6.65-7.05-6.08-11.51,0,0,7.12,3.73,10.31,1.74l-1.64-3.13a19.48,19.48,0,0,1,12.37,4.35,91.12,91.12,0,0,0,19.77-5.73,40.45,40.45,0,0,1,5.71-2,10.35,10.35,0,0,1,6,.16,6,6,0,0,1,3.87,4.33,6.41,6.41,0,0,1-2.21,5.62,15.81,15.81,0,0,1-5.52,3C315.47,270.91,284.89,273.59,281.09,271.2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.91,192.43a9.87,9.87,0,0,1-2.74-13,5.37,5.37,0,0,1-2.6-2.44,2.87,2.87,0,0,1,3.73-3.83,4,4,0,0,1,1.6-4.7,3.8,3.8,0,0,1,4.73.88,2.56,2.56,0,0,1,1.75-2.53,5.21,5.21,0,0,1,3.28.2c1,.36,2,.89,3.11,1.22a24.17,24.17,0,0,0,5.58.72,11.24,11.24,0,0,1,5.39,1.43c1.58,1,3,3.41,2.12,5.47a3.11,3.11,0,0,1,2.24-1.19,3,3,0,0,1,2.3,1c-1.17.73-2.31,1.51-3.48,2.24a3.17,3.17,0,0,1,3.58,1.43,7.12,7.12,0,0,1,.63,3.78,50.31,50.31,0,0,1-2.6,14.48c-.8,2.42-2,5-4.25,6.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.37,204.06l.51,5.77a2.24,2.24,0,0,1-.32,1.28,3.27,3.27,0,0,0,.5,3.77,4.29,4.29,0,0,0,2.58.87,12.44,12.44,0,0,0,9.54-3.68,2.67,2.67,0,0,0,.76-2l-.38-14.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.4,196.21l-12,7.85.45,5.12c2.8-.66,5.62-1.46,7.83-3.26A10.75,10.75,0,0,0,328.4,196.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.25,180.54a51.59,51.59,0,0,0,1.29,20,15.65,15.65,0,0,0,1.59,4.11,6.67,6.67,0,0,0,3.25,2.89,10.29,10.29,0,0,0,5.37,0c3.27-.57,6.62-1.18,9.46-2.9s5.08-4.82,4.81-8.13a5.66,5.66,0,0,0,5.42.3,5.72,5.72,0,0,0,3-4.59c.13-1.86-.94-3.92-2.76-4.28a4,4,0,0,0-3.16.92,11.83,11.83,0,0,0-2.21,2.57,3.88,3.88,0,0,1-1.1,1.18,1.32,1.32,0,0,1-1.51,0,2,2,0,0,1-.43-1.65l.19-4.19a1.67,1.67,0,0,0-.93-1.56,4.12,4.12,0,0,1-1.88-2.16,8.65,8.65,0,0,1-.53-2.52,1,1,0,0,0-1.41-.88A30.89,30.89,0,0,1,303.25,180.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.46 190.7 308.7 197.04 313.19 197.89 312.46 190.7",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52,200.07l-3.41,1.66a2.22,2.22,0,0,0,2.59.74A2,2,0,0,0,317.52,200.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52,200.07l-3.41,1.66a2.22,2.22,0,0,0,2.59.74A2,2,0,0,0,317.52,200.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51,202.58a2,2,0,0,0,1.19-.11,1.83,1.83,0,0,0,.91-1.8,2.13,2.13,0,0,0-1.35.47A2.17,2.17,0,0,0,315.51,202.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,191a1.29,1.29,0,0,1-1.15,1.42,1.31,1.31,0,0,1-1.42-1.16A1.29,1.29,0,0,1,319,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.15,191.62a1.29,1.29,0,1,1-1.41-1.15A1.28,1.28,0,0,1,308.15,191.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,186.64l-2.65,2.25a1.84,1.84,0,0,1,.35-2.07A2.19,2.19,0,0,1,306.39,186.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,185.38l3,1.68a1.85,1.85,0,0,0-.76-2A2.16,2.16,0,0,0,317.37,185.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,241.84l-5.81,15,6.41,10c9.34-4.24,7.42-3,13.88-18.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.39,210.87c-7,8.28-9.63,22.51-13.25,31.66,4.05,7.66,15.33,6.92,15.33,6.92C350.79,228,355.16,211.74,338.39,210.87Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalsiteAmico);
export default __webpack_public_path__ + "static/media/Personal site-amico.061dcb496c12bef05e33a9607cd34352.svg";
export { ForwardRef as ReactComponent };